import React from "react";

const QuoteIcon = ({color}) => {
  return (
	  <svg className="w-6 sm:w-9 lg:w-1/12 mb-2.5 lg:mb-6 transform rotate-180" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill={color}><path d="M0 4v12h8c0 4.41-3.586 8-8 8v4c6.617 0 12-5.383 12-12V4H0zM20 4v12h8c0 4.41-3.586 8-8 8v4c6.617 0 12-5.383 12-12V4H20z"/></g></svg>
  )
}

export default QuoteIcon;
